import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApplicationByProjects } from '../../services/application'

export const getApplicationsAction = createAsyncThunk(
  'applications/getByProjects',
  async ({ ids, state, pagination, filter }, { rejectWithValue }) => {
    try {
      const data = await getApplicationByProjects(ids, state, pagination, filter)

      return data.data
    } catch (e) {
      return rejectWithValue(e.response.data)
    }
  }
)

export const applicationSlice = createSlice({
  name: 'application',
  initialState: {
    applications: [],
    currentApplication: null,
    meta: {},
    searchFilter: {},
    pagination: {},
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
  },
  reducers: {
    clearState: (state) => {
      state.isError = false
      state.isSuccess = false
      state.isFetching = false

      return state
    },
    setSearchFilter: (state, { payload }) => {
      state.searchFilter = payload.filter
      return state
    },
    setApplication: (state, { payload }) => {
      state.currentApplication = payload.application
      return state
    },
    setApplicationItem: (state, { payload }) => {
      state.currentApplicationItem = payload.applicationItem
      state.currentImplementationId = payload.implementationId
      return state
    },
    updateOffer: (state, { payload }) => {
      const offer = state.currentApplication?.implementation?.implementation_offers.find(
        (file) => file.id === payload.id
      )
      if (offer) {
        offer.number = payload.number
        offer.date = payload.date
      }
    },
  },
  extraReducers: {
    [getApplicationsAction.fulfilled]: (state, { payload, meta }) => {
      state.applications = payload.data.attributes.results
      state.pagination = payload.data.attributes.pagination
      state.meta = meta.arg
      state.isFetching = false
      state.isSuccess = true
      return state
    },
    [getApplicationsAction.rejected]: (state, { payload }) => {
      state.isFetching = false
      state.isError = true
      state.errorMessage = payload.message
      state.meta = {}
    },
    [getApplicationsAction.pending]: (state) => {
      state.isFetching = true
    },
  },
})

export const { clearState, setSearchFilter, setApplication, setApplicationItem, updateOffer } = applicationSlice.actions

export const applicationSelector = (state) => state.application
export const currentApplicationSelector = (state) => state.application?.currentApplication
export const implementationOffersSelector = (state) =>
  state.application?.currentApplication?.implementation?.implementation_offers
